import { Component, h } from 'preact';

interface PaginationDotsProps {
  pageCount: number;
  currentPage: number;
  /**
   * Called when a page dot is clicked. Numbering starts at 1.
   */
  onPageSelect: (page: number) => void;
}

export class PaginationDots extends Component<PaginationDotsProps> {
  render() {
    const { pageCount, currentPage } = this.props;
    const iconClasses: string[] = [];

    for (let i = 1; i <= pageCount; i++) {
      // This component follows CSS numbering, which starts at 1
      const icon = i == currentPage ? 'fas fa-circle' : 'far fa-circle';
      iconClasses.push(icon);
    }

    return (
      <div className="hi-pgndots">
        { iconClasses.map((classes, index) =>
          <i
            className={`${classes} hi-inqpage__slide-pager-button`}
            onClick={ () => this.props.onPageSelect(index + 1) } />
        ) }
      </div>
    );
  }
}